module.exports = __webpack_public_path__ + "img/30_32.870e6c6a.png";